/** Decorative artwork: all meaningful program and record information remains in HTML. */
const scenes = [
  "ai-everyday-life",
  "prompt-context-engineering",
  "governance-safety",
  "product-design-studio",
  "data-knowledge-systems",
  "automation-workflows",
  "builder-lab",
  "team-institution",
];
export function AcademyImage({
  subject = "",
  index,
  hero = false,
}: {
  subject?: string;
  index?: number;
  hero?: boolean;
}) {
  const text = subject.toLowerCase();
  const sceneIndex =
    index === undefined
      ? [...subject].reduce((sum, letter) => sum + letter.charCodeAt(0), 0)
      : Math.max(0, index);
  const scene =
    index !== undefined
      ? scenes[sceneIndex % scenes.length]
      : /organization|team/.test(text)
        ? "team-institution"
        : /school|institution/.test(text)
          ? "product-design-studio"
          : /proctor/.test(text)
            ? "data-knowledge-systems"
            : /parent|family|child|guardian/.test(text)
              ? "family-learning"
              : /project|build|lab/.test(text)
                ? "collaborative-project"
                : /learn|welcome|command/.test(text)
                  ? "learner-studio"
                  : scenes[sceneIndex % scenes.length];
  return (
    <img
      className={hero ? "academy-scene academy-scene-hero" : "academy-scene"}
      src={`/images/academy/${scene}${hero ? "" : "-card"}.webp`}
      alt=""
      loading={hero ? "eager" : "lazy"}
      decoding="async"
      width="960"
      height="540"
    />
  );
}
